import { User } from '@apis/index'
import { switchOff, switchOn, totalusers } from '@assets/icons'
import Svg from '@components/svg'
import Table from '@components/table'
import UserProfile from '@components/userprofile'
import { useModal } from '@context/ModalContext'
import { RootState } from '@store/index'
import { Helper } from '@utils/index'
import theme from '@utils/theme'
import { Eye } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import UserDetailModal from '@commons/user-detail-modal'

const Staff = ({ user }) => {
  const { showModal } = useModal()
  const navigate = useNavigate()
  const [searchTerm] = useState('')
  const {
    items: users,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.users)
  const [page, setPage] = useState(1)
  const fetchUsers = async (search = '', page = 1) => {
    try {
      await User.staffs({
        state: 'users',
        params: {
          page,
          search,
          createdBy: user.id,
        },
      })
    } catch (error) {}
  }
  const column = [
    {
      title: 'Staff Detail',
      key: 'staffDetail',
      render: (item) => <UserProfile item={item} />,
    },
    {
      title: 'Mobile Number',
      key: 'mobileNumber',
      render: (item) => item.phoneNo,
    },
    {
      title: 'Permission Module',
      key: 'permissionModule',
      render: (item) => (
        <>
          {item?.permissions?.permissions?.map((item) => (
            <p key={item.id}>{item}</p>
          ))}
        </>
      ),
    },
    {
      title: 'Created At',
      key: 'createdAt',
      render: (item) => (
        <>
          <p> {Helper.formatDate(item.createdAt)}</p>
          <p> {Helper.formatTime(item.createdAt)}</p>
        </>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Svg
          src={item.isActive ? switchOn : switchOff}
          onClick={async () => {
            await User.updateStatus({
              state: 'users',
              id: item.id,
              data: { isActive: !item.isActive },
            })
          }}
        />
      ),
    },
  ]
  useEffect(() => {
    if (user.id) fetchUsers(searchTerm, page).then(() => {})
  }, [page, searchTerm, user.id])

  return (
    <>
      <br />
      <Table
        text="Staff Management"
        icon={totalusers}
        data={users}
        columns={column}
        totalItems={totalItems}
        totalPages={totalPages}
        loading={loading}
        itemsPerPage={20}
        pageControlled={page}
        onPageChange={setPage}
        actions={[
          {
            key: 'view',
            icon: <Eye color={theme.colors.primary} />,
            onClick: (item) => {
              showModal(<UserDetailModal item={item} />)
            },
          },
        ]}
        hasExportButton={true}
        savedTitle={'Staff.pdf'}
      />
    </>
  )
}

export default Staff
